import React from "react";
// Direct import from the main desktop script to keep features synced
import LotCalculate from "../../pages/LotCalculate";

export default function MobileLotCalculate() {
  return (
    <div style={styles.container}>
      <div style={styles.contentWrapper}>
        <LotCalculate />
      </div>

      <style>{`
        /* Overrides to make the desktop component mobile-friendly */
        .lot-calculator-card {
          width: 100% !important;
          max-width: 100% !important;
          margin: 0 !important;
          padding: 15px !important;
          box-shadow: none !important;
          background: transparent !important;
        }

        /* Adjusting any internal desktop grids to single column */
        .calculator-grid {
          display: flex !important;
          flex-direction: column !important;
          gap: 15px !important;
        }
      `}</style>
    </div>
  );
}

const styles = {
  container: {
    width: "100%",
    minHeight: "100vh",
    background: "#080b11",
    padding: "16px",
    paddingTop: "10px", // Adjusted to sit better under the MobileHeader
    boxSizing: "border-box",
  },
  contentWrapper: {
    width: "100%",
    maxWidth: "100%",
    margin: "0 auto",
  }
};